import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Deal } from 'views/Deals/types';
import { IVariables } from '../types';

const createDeal = async ({ postData, orgId }: IVariables): Promise<Deal> => {
    const response = await axiosInstance.post(`${API_ENDPOINTS.DEALS(orgId)}`, postData);
    return response.data;
};

export const useCreateDeal = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createDeal,
        onSuccess: (data, variables) => {
            // Invalidate all deal-related queries
            queryClient.invalidateQueries({ queryKey: ['deals', variables.orgId] });
        },
    });
};
